export default function formatDate(
  dateStr?: string,
  options?: Intl.DateTimeFormatOptions
): string {
  if (!dateStr || new Date(dateStr).toString() === "Invalid Date") {
    return "";
  }

  const date = new Date(dateStr);
  return new Intl.DateTimeFormat(
    window.navigator.language,
    options || {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZone: process.env.TZ,
    }
  ).format(date);
}

export function formatDateAndTimeWithLongString(dateStr?: string): string {
  if (!dateStr || new Date(dateStr).toString() === "Invalid Date") {
    return "";
  }

  const date = new Date(dateStr);

  const day = new Intl.DateTimeFormat(window.navigator.language, {
    day: "numeric",
    timeZone: process.env.TZ,
  }).format(date);

  const month = new Intl.DateTimeFormat(window.navigator.language, {
    month: "long",
    timeZone: process.env.TZ,
  }).format(date);

  const year = new Intl.DateTimeFormat(window.navigator.language, {
    year: "numeric",
    timeZone: process.env.TZ,
  }).format(date);

  const time = new Intl.DateTimeFormat(window.navigator.language, {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: process.env.TZ,
  }).format(date);

  return `${day} ${month} ${year} @ ${time}`;
}

export function formatDateAndTimeWithShortString(
  date: string,
  includeTime = false,
  includeSeconds = false
): string {
  if (!date || new Date(date).toString() === "Invalid Date") {
    return "";
  }

  const day = formatDate(date, {
    day: "numeric",
    timeZone: process.env.TZ,
  });
  const month = formatDate(date, {
    month: "short",
    timeZone: process.env.TZ,
  });
  const year = formatDate(date, {
    year: "numeric",
    timeZone: process.env.TZ,
  });
  const time = formatDate(date, {
    hour: "2-digit",
    minute: "2-digit",
    second: includeSeconds ? "2-digit" : undefined,
    hour12: false,
    timeZone: process.env.TZ,
  });

  return includeTime
    ? `${month} ${day}, ${year}, ${time}`
    : `${month} ${day}, ${year}`;
}
